// extracted by mini-css-extract-plugin
module.exports = {"banner-picture":"banner-picture-6fa81944d9fb7cd9f6f4d33e102f9594"};